export default __webpack_public_path__ + "static/media/landscape23.30a94fe9.JPG";